<div class="thirds-container">
  <div class="thirds-block flex-column-container">
    <label i18n="@@railTravellerInfoName" class="header-label">Name</label>
    <input
      [(ngModel)]="traveller.name"
      (ngModelChange)="searchParams.travellersUpdate()"
      appInput
      type="text"
      name="travellerNameInput"
      aria-label="Enter Traveller Name"
      i18n-placeholder
      placeholder="Enter Traveller Name"
      required
    />
  </div>

  <div class="thirds-block flex-column-container">
    <label i18n="@@railTravellerInfoAge" class="header-label">Age Range</label>
    <select
      [(ngModel)]="traveller.ageRange"
      (ngModelChange)="searchParams.travellersUpdate()"
      appSelect
      aria-label="Enter Traveller Age"
      required
      name="travellerAgeInput"
      id="travellerAgeInput"
    >
      @for (ageRange of searchParams.trainlineAgeRanges; track ageRange) {
        <option [value]="ageRange.value">{{ ageRange.display }}</option>
      }
    </select>
    <section [hidden]="traveller.ageRange != 'youth'">
      <label i18n="@@railExactAge">Exact Age</label>
      <input
        appInput
        [ngClass]="{ 'ng-invalid': ageInvalid }"
        type="string"
        (ngModelChange)="updateAge($event); searchParams.travellersUpdate()"
        i18n-placeholder
        placeholder="Enter exact age."
        aria-label="Exact age"
        id="travellerExactAge"
        [(ngModel)]="traveller.age"
      />
    </section>
  </div>

  <div class="thirds-block flex-column-container">
    <label i18n="@@railTravellerInfoLoyalty" class="header-label">Loyalty and Discount</label>
    @for (loyalty of traveller.loyalties; track loyalty; let i = $index) {
      <div class="thirds-container">
        <section class="loyalty-section-container">
          <select
            [(ngModel)]="loyalty.loyaltyCode"
            (ngModelChange)="
              searchParams.travellersUpdate(); railCardSelected($event, traveller, i)
            "
            appSelect
            aria-label="Enter Loyalty Scheme"
            name="travellerLoyaltyInput"
          >
            <option [value]="''" i18n="@@SelectALoyaltyScheme">Select a loyalty scheme</option>
            @for (card of railCards; track card) {
              <option [value]="card.code">{{ card.name }}</option>
            }
          </select>
          @if (loyalty.loyaltyNumberRequired) {
            <section class="loyalty-section">
              <label i18n="@@loyaltyNumber">Loyalty or Discount Number</label>
              <input
                [(ngModel)]="loyalty.loyaltyNumber"
                (ngModelChange)="searchParams.travellersUpdate()"
                aria-label="Loyalty Number"
                appInput
                [ngClass]="{ 'input-prefix': loyalty.loyaltyPrefix }"
                i18n-placeholder
                placeholder="Enter Card Number"
                pattern="{{ loyalty.loyaltyPattern }}"
                required
              />
              @if (loyalty.loyaltyPrefix) {
                <span class="loyalty-prefix">{{ loyalty.loyaltyPrefix }}</span>
              }
            </section>
          }
        </section>
        <button class="delete-button" (click)="removeCard(i)" aria-label="Remove Card" i18n-label>
          <i class="ico-cancel" aria-hidden="true"></i>
        </button>
      </div>
    }
    <div class="flex-row-container flex-row-container--right">
      <button
        class="link-button add-card"
        (click)="addNewCard()"
        aria-label="Add another Loyalty/Discount"
        i18n="@@addCard"
      >
        Add another Loyalty/Discount
      </button>
    </div>
  </div>
</div>
